import { createFileRoute } from "@tanstack/react-router";
import { DashboardContent } from "@/components/dashboard";
import { usePageTitle } from "@/hooks/use-page-title";

export const Route = createFileRoute("/dashboard/")({
  component: DashboardPage,
});

function DashboardPage() {
  usePageTitle("Dashboard");
  return <DashboardContent />;
}
